/**
 * AJAX REQUEST
 * @type {{post: ajax.post, get: ajax.get, x: ((function(): (XMLHttpRequest))|*), send: ajax.send}}
 */
const ajax = {
	x: function () {
		if (typeof XMLHttpRequest !== 'undefined') {
			return new XMLHttpRequest();
		}
		let versions = [
			"MSXML2.XmlHttp.6.0",
			"MSXML2.XmlHttp.5.0",
			"MSXML2.XmlHttp.4.0",
			"MSXML2.XmlHttp.3.0",
			"MSXML2.XmlHttp.2.0",
			"Microsoft.XmlHttp"
		];

		let xhr;
		for (let i = 0; i < versions.length; i++) {
			try {
				xhr = new ActiveXObject(versions[i]);
				break;
			} catch (e) {}
		}
		return xhr;
	},

	send: function (url, callback, method, data, async, isQuery) {
		if (async === undefined) {
			async = true;
		}
		let x = ajax.x();
		x.open(method, url, async);
		x.onreadystatechange = function () {
			if (x.readyState === 4) {
				let response = x.responseText;

				if (x.getResponseHeader('content-type') === 'application/json') {
					response = JSON.parse(response);
				}

				switch (x.status) {
					case 200:
						callback('success', response);
						break;
					default:
						callback('error', response);
						break;
				}
			}
		};
		if (method === 'POST' && isQuery) {
			x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		}
		x.send(data)
	},

	get: function (url, data, callback, async) {
		let query = [];
		if (Array.isArray(data)) {
			for (let key of data) {
				query.push(encodeURIComponent(key[0]) + '=' + encodeURIComponent(key[1]));
			}
		} else {
			for (let key in data) {
				query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
			}
		}

		ajax.send(url + (query.length ? '?' + query.join('&') : ''), callback, 'GET', null, async)
	},

	post: function (url, data, isQuery = false, callback, async) {
		if (isQuery) {
			let query = [];

			for (let key in data) {
				query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
			}

			data = (query.length ? '' + query.join('&') : '');
		}

		ajax.send(url, callback, 'POST', data, async, isQuery)
	}
};

export { ajax }
